import {ajax} from '../../api/ajax';
import {NETWORK_REQUEST_BEGUN, NETWORK_REQUEST_FINISHED} from '../action-types';

export function networkRequestBegun() {
  return {
    type: NETWORK_REQUEST_BEGUN,
  };
}

export function networkRequestFinished() {
  return {
    type: NETWORK_REQUEST_FINISHED,
  };
}

export function doNetworkRequest(method, endpoint, data) {
  return (dispatch) => {
    dispatch(networkRequestBegun());
    return ajax(method, endpoint, data)
      .finally(() => dispatch(networkRequestFinished()));
  };
}

export function post(endpoint, data) {
  return doNetworkRequest('POST', endpoint, data);
}
